import { render } from "./AgreementCard.vue?vue&type=template&id=0c7adb47&scoped=true&ts=true"
import script from "./AgreementCard.vue?vue&type=script&lang=ts"
export * from "./AgreementCard.vue?vue&type=script&lang=ts"

import "./AgreementCard.vue?vue&type=style&index=0&id=0c7adb47&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7adb47"]])

export default __exports__